module.exports = __webpack_public_path__ + "media/images/fake/002-59bead83b8dacaab146da20afecf8341.jpg";